import axios from 'axios'
// import axios from '../../../utils/axios';

const baseUrl = process.env.REACT_APP_API_URL;

function clean(obj) {
    Object.keys(obj).forEach((item) =>
        !obj[item] ? delete obj[item] : obj[item],
    )
    return obj
}
const createCouponCode = async(data) => {
    const path = `/api/user/createCouponCode`
    const url = baseUrl + path
    const dataa = {
        percent_off: data.percentage_amount,
        duration: data.duration,
        name: data.descriptionsCode,
        days: data.durationDays,
        max_redemptions: data.durationQuantity,
        duration_in_months: data.durationInMonth,
        amount_off: data.fixed_amount,
        currency: data.currency,
    }

    clean(dataa)

    const response = await axios.post(url, dataa)
    return response.data
}

const getAllDBCoupons = async(page) => {
    const path = `/api/user/getAllDBCoupons/${page || ''}`
    const url = baseUrl + path
    const response = await axios.get(url)
    return response.data
}

// deleteDBCoupon
const deleteDBCoupon = async(id) => {
    const path = `/api/user/deleteCoupon/${id}`
    const url = baseUrl + path
    const response = await axios.delete(url)
    return response.data
}

const deleteAllDBCoupon = async(data) => {
    const path = `/api/user/deleteMultipleCoupon`
    const url = baseUrl + path
    const dataaa = [...data]
    const response = await axios.post(url, dataaa)
    return response.data
}

const editDBCoupon = async(data) => {
    const dataaaa = clean(data)
    const path = `/api/user/updateCoupon/${data.Id}`
    const url = baseUrl + path
    const response = await axios.put(url, dataaaa)
    return response.data
}

// status
const changeStatusCoupen = async(data) => {
    const path = `/api/user/changeCouponStatus/${data.id}`
    const url = baseUrl + path
    const dataa = {
        status: data.status,
    }

    const response = await axios.put(url, dataa)
    return response.data
}

const codeServices = {
    createCouponCode,
    getAllDBCoupons,
    deleteDBCoupon,
    editDBCoupon,
    changeStatusCoupen,
    deleteAllDBCoupon,
}
export default codeServices